<template>
  <div class="page">
    <div class="locations-white locations-generic contact centered-box">
      <section>
        <!-- <div class="locations-title">Contact</div>  -->
      </section>
        <a href="mailto:Info@ChicagoRiverPaddle.com">
          <i class="far fa-envelope"></i>
          Info@ChicagoRiverPaddle.com
        </a><br>
        <call-button tel-number="224-415-6554"/>Busse Reservoir<br>
        <call-button tel-number="773-704-2663"/>Clark Park Boathouse<br>
        <!-- <call-button tel-number="708-506-0227"/>Maple Lake<br> -->
        <call-button tel-number="847-414-5883"/>Skokie Lagoons<br>
        <call-button tel-number="708-830-5194"/>Lake Tampier<br>
  </div>
  </div>
</template>

// <script>
import CallButton from './CallButton'
export default {
  name: 'Contact',
  components: {
    CallButton,
  },
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page {
  background-image: url("../assets/pic1.png");
  flex-direction: column;
}
section {
  margin-bottom: 10px;
}
a:hover {
color: white !important;
}
a {
margin-bottom: 14px;
display: inline-block;
color: black !important;    
}
@media screen and (max-width: 768px) {
  .contact { 
    width: 90%;
  }
}
.call-button {
  margin-right: 20px; 
}
.fa-envelope {
  font-size: 50px;
  margin-right: 40px;
  color: white;
}
</style>
